export const DELEGATE_ALERT = 'DELEGATE_ALERT';
export const DELEGATE_ALERT_SUCCESS = 'DELEGATE_ALERT_SUCCESS';
export const DELEGATE_ALERT_FAIL = 'DELEGATE_ALERT_FAIL';

export const FETCH_DELEGATE_TEAMS = 'FETCH_DELEGATE_TEAMS';
export const FETCH_DELEGATE_TEAMS_SUCCESS = 'FETCH_DELEGATE_TEAMS_SUCCESS';
export const FETCH_DELEGATE_TEAMS_FAIL = 'FETCH_DELEGATE_TEAMS_FAIL';
